<template>
  <header class="header-container">
        <div
          class="dropdown-menu-button"
          @click="$emit('changeMenuViewState')"
        >
          <v-icon
            large
            color="#008B52"
          >
            mdi-view-headline
          </v-icon>
        </div>
      <div class="logo-container">
        <img 
          src="../assets/logo-pemex-og.png" 
          alt="logo pemex"
          class="logo"
        >
      </div>
      <div 
        class="logout-button"
        @click="logOut"
      >
        Cerrar sesión
         <v-icon
          medium
          color="#008B52"
          class="logo"
        >
          mdi-logout
        </v-icon>
      </div>
    </header>
</template>

<script>
import { EventDriver } from '../utils/EventDriver';
export default {
  name: "Header",
  methods: {
    logOut() {
      EventDriver.$emit('logOut');
    },
    changeState() {
      this.unactive = !this.unactive
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.app {
  height: 100%;
  width: 100%;
}
.header-container {
  background: var(--principal-color);
  width: 100%;
  height: 7%;
  min-height: 60px;
  display: grid;
  padding: 0 10px;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.dropdown-menu-button {
  justify-self: start;
  cursor: pointer;
}
.dropdown-menu-button:active {
  transform: scale(0.9);
}
.logo-container {
  height: 60px;
}
.logo {
  max-height: 60px;
  min-height: 60px;
  margin: 0;
}
.logout-button {
  justify-self: end;
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 1.2rem;
}
</style>